import Vue from 'vue'
import { store } from '@/store.js'
import lang from "@/lang.js";
import App from './App.vue'
import persist from '@/persist.js'

Vue.config.productionTip = true;

const language = (window.navigator.userLanguage || window.navigator.language || 'en').substring(0, 2);

if (location.protocol == 'http:') {
    if (location.hostname != 'localhost') {
        //location.replace(`https:${location.href.substring(location.protocol.length)}`);
        location.replace('https://psymet.online');
    }
    //console.log(location);
}

//console.log('main.js lang: ' + language);

var shared = {
    browser_lang: language,
    text: lang.getLocalisedText(language)
};

shared.install = function () {
    Object.defineProperty(Vue.prototype, '$shared', {
        get() { return shared }
    })
}


Vue.use(shared);

const root = new Vue({
    el: '#app',
    store,
    render: h => h(App)
});


Vue.config.errorHandler = (err, vm, info) => {
    // vm is undefined for errors outside any component, e.g. in Vue.nextTick().
    const tag = vm ? vm.$options._componentTag : undefined;
    /* eslint-disable no-console */
    //console.log(`err: [${err}] [${tag}]`);
    root.$store.commit("showError", `${err} - ${tag}`);
    /* eslint-enable no-console */

    persist.report_error('vue', err, `${info} <${tag}>`);

    // return false to stop the propagation of errors further to parent or global error handler:
    return false;
}

window.onerror = function (message, source, lineno, colno, error) {
    /* eslint-disable no-console */
    //console.log(`err: ${error}.`);
    /* eslint-enable no-console */
    // Errors from scripts of other origins (e.g. browser extensions) come without the error
    // object, only as "Script error.". The participant can't act on that, so it is reported only.
    if (error) {
        root.$store.commit("showError", `${error}`);
    }

    persist.report_error('error', error || message, `${source}:${lineno}:${colno}`);
    return true;
};

// Promises that reject with nobody to handle it (most of persist.js is async). Reported only:
// as before, the participant sees no banner for them.
window.addEventListener('unhandledrejection', event => persist.report_error('rejection', event.reason));

